import { TabPanel } from "@mui/lab";
import {
  Box, 
} from "@mui/material";
import styled from "styled-components";
import CardTitle from "../../components/CardTitle";

export const CustomTabPanel = styled(TabPanel)(({ theme }) => ({
  padding: theme.spacing(4, 0),
}));

export const CustomCardTitle = styled(CardTitle)(({ theme }) => ({
  marginBottom: `${theme.spacing(4)} !important`,
}))

export const StyledTabTitle = styled(Box)(({ theme }) => ({
  color: theme.palette.white.main,
  fontWeight: 'bold',
  fontSize: '16px',
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(1),
  textTransform: 'capitalize',
  marginBottom: `${theme.spacing(2)} !important`,
}))